import { type JanusCtx, HandBack, upper } from '../ability/context.js';
import { removeStoredStatus } from '../ability/statuses/status-effect-removal-helpers.js';
import { paoeEntryVerdict, type PaoeEntryVerdict } from '../ability/paoe-entry.js';
import { type ZoneStrip, MAX_ZONE_STRIPS } from './walk-zone-crossings.js';

/** The classifier already decided the exits. Resolve exact rows and their loss/link/support tails on one snapshot. */
export function resolveZoneExit(ctx: JanusCtx, strips: readonly ZoneStrip[]): PaoeEntryVerdict {
  if (strips.length > MAX_ZONE_STRIPS) throw new HandBack('zone-exit:write-limit');
  const firstRow = ctx.rows.length;
  for (const strip of strips) {
    const target = ctx.members.get(upper(strip.targetId));
    if (!target) throw new HandBack('zone-exit:target-not-held');
    const status = ctx.read.statuses(target).find(s => upper(s.status_id) === upper(strip.statusId));
    if (!status || ctx.statusesRemoved.some(s => upper(s.status_id) === upper(strip.statusId))) continue;
    removeStoredStatus(ctx, target, status, 'single', { skipConnectedPeerCull: true });
  }
  // Surface chemistry has an explicit deferred-transport policy; its omission does not undo an otherwise complete exit.
  const skipped = ctx.rows.slice(firstRow).find(row => row.roll_type_1 === 'janus_unported_skip'
    && !String(row.rolls_full ?? '').startsWith('surface-reaction:'));
  if (skipped) throw new HandBack(`zone-exit:tail-skipped:${String(skipped.rolls_full ?? 'unnamed-tail')}`);
  // The spell identifies the zone's provenance; an exit never casts it or examines armed watches.
  return { ...paoeEntryVerdict(ctx), counterspellExempt: true };
}
